import { Component, Input } from '@angular/core';
import { of } from 'rxjs';
import { AuthFacade } from 'src/app/auth/store/auth.facade';
import { HeaderMenu2 } from '../../models/header-menu2.models';

@Component({
  standalone: false,
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss']
})
export class HeaderMenuComponent {

  @Input() menuItem: HeaderMenu2;

  headerMenu2$ = this.authFacade.headerMenu2$;
  loggedInUser$ = this.authFacade.loggedInUser$;
  isLoggedIn$ = this.authFacade.isLoggedIn$;

  constructor(private authFacade: AuthFacade) {
  }

  GetChilds(menuItem: HeaderMenu2) {
    if (menuItem.ChildCount > 0 && menuItem.Id) {
      var a = this.authFacade.selectHeaderMenu2FromParentId(menuItem.Id);
      return a;
    }
    else
      return of([]);
  }

  onLogout() {
    this.authFacade.logout();
  }
}
